<template>
  <div>
    <!--    <v-btn-->
    <!--      color="color_action"-->
    <!--      absolute-->
    <!--      top-->
    <!--      fixed-->
    <!--      right-->
    <!--      class="mt-14"-->
    <!--      @click="openDialog()"-->
    <!--    >-->
    <!--      <v-icon left> mdi-send </v-icon>-->
    <!--      {{ $t("btn.relance") }}-->
    <!--    </v-btn>-->
    <v-dialog v-model="dialog" persistent>
      <v-card flat class="white">
        <v-card-title />
        <v-card-text>
          <v-data-table
            class="mt-3"
            :items-per-page="5"
            :headers="ligneHeaders"
            :items="ligneStructsOk()"
            item-key="id"
            :item-class="itemRowClass"
            @click:row="ToogleLigne"
          >
            <template #[`item.statut`]="{ item }">
              <v-icon v-if="item.statut" color="color_success">
                mdi-check-circle-outline
              </v-icon>
              <v-icon v-else color="color_danger"> mdi-alert-outline </v-icon>
            </template>
            <template #[`item.facturette`]="{ item }">
              <v-icon v-if="item.facturette" color="color_success">
                mdi-check-circle-outline
              </v-icon>
              <template v-else>
                <v-icon color="color_danger"> mdi-alert-outline </v-icon>
              </template>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text>
          <v-textarea
            v-model="commentaire"
            :label="$t('rob.relance.commentaire')"
          />
        </v-card-text>
        <v-card-subtitle>
          <v-row>
            <v-spacer />
            <v-btn
              :disabled="commentaire === ''"
              color="color_action"
              @click="sendRelance()"
            >
              <v-icon left dark> mdi-send </v-icon> {{ $t("btn.send") }}
            </v-btn>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-sheet max-height="500px" class="overflow-auto">
            <affiche-relances :relances="relances" />
          </v-sheet>
        </v-card-text>
        <v-card-actions class="white">
          <v-spacer />
          <v-btn color="color_action" @click="closeDialog()">
            <v-icon left dark> mdi-close </v-icon>{{ $t("btn.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { relanceMixin } from "@/mixins/relance";
import { generalMixin } from "@/mixins/general";
import afficheRelances from "@/components/afficheRelances";
import { ligneRobMixin } from "@/mixins/ligneRob";

export default {
  name: "VueDialogRelance",
  components: {
    afficheRelances,
  },
  mixins: [relanceMixin, generalMixin, ligneRobMixin],
  data() {
    return {
      commentaire: "",
      dialog: false,
      selectLigne: [],
    };
  },
  computed: {
    ligneHeaders() {
      return [
        {
          text: this.$t("ligneRob.statut"),
          align: "start",
          sortable: true,
          value: "statut",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.facturette"),
          align: "start",
          sortable: true,
          value: "facturette",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.montantTTC"),
          align: "start",
          sortable: true,
          value: "montant_ttc",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.fournisseur"),
          align: "start",
          sortable: true,
          value: "fournisseur",
          class: "color_thead lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.carte"),
          align: "start",
          sortable: true,
          value: "carte_name",
          class: "color_thead lighten-2 white--text",
        },
      ];
    },
  },
  methods: {
    ligneStructsOk() {
      return this.ligneStructs.filter((item) => item.annule === false);
    },
    ToogleLigne(event, { item }) {
      const a = this.selectLigne.findIndex((val) => val.id === item.id);
      if (a !== -1) this.selectLigne.splice(a, 1);
      else this.selectLigne.push(item);
    },
    closeDialog() {
      this.commentaire = "";
      this.dialog = false;
    },
    itemRowClass(item) {
      return this.selectLigne.findIndex((val) => val.id === item.id) !== -1
        ? "color_select--text"
        : "";
    },
    sendRelance() {
      const values = {
        commentaire: this.commentaire,
        lignesRob: this.selectLigne.map(function (obj) {
          return obj.id;
        }),
        sb: this.paramsRob.structureId,
        rob: this.paramsRob.robId,
      };
      this.closeDialog();
      this.createRelance(values);
    },
    openDialog() {
      this.selectLigne = [];
      this.getligneStructs({
        robId: this.paramsRob.robId,
        structId: this.paramsRob.structureId,
      });
      this.getRelances({
        robId: this.paramsRob.robId,
        structureId: this.paramsRob.structureId,
      });
      this.dialog = true;
    },
  },
};
</script>

<style scoped></style>
